// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"2c23cba9","702":"a23f7f09","977":"21c841a8"}[chunkId] + ".chunk.css";
};